<template>
  <a-table :columns="columns" :data-source="data" bordered size="small" :pagination="false"
    :locale="{ emptyText: '暂无数据' }" :scroll="{ x: 'calc(700px + 50%)', y: height }" />
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";
export default {
  name: "OrderCalcDetail",
  data() {
    return {
      data: [],
      columns: [],
      height: 600,
    };
  },
  computed: {
    ...mapState(["role", "username"]),
  },
  components: {
  },
  watch: {

  },
  mounted() {
    this.height = window.innerHeight - 280;
    window.onresize = (e) => {
      console.log("onresize", window.innerHeight);
      this.height = window.innerHeight - 280;
    };
  },
  methods: {
    getdata(payload) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/waybill/calc", payload).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          if (payload.action && res.data.url) {
            return this.$download(res.data.url, res.data.name);;
          }
          this.makedata(res.data);
        } else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    makedata({ sources: headers, targets }) {
      let columns = [];
      for (let i = 0; i < headers.length; i++) {
        let { from, to } = headers[i];
        let header = `${from}-${to}`;
        columns.push({
          title: header,
          children: [
            {
              title: "出发",
              children: [
                {
                  title: '12T',
                  dataIndex: `${header}__12T`,
                  width: 80,
                  align: 'center',
                  customCell: (record, rowIndex) => {
                    return {
                      style: {
                        fontSize: '11px',
                      }
                    };
                  },
                  customRender: (value, record, index) => {
                    let vehicle_type = "12";
                    let time = record[`${header}__${vehicle_type}T`];
                    let vehicle_number = record[`${header}__${vehicle_type}__vehicle_number`];
                    if (time && vehicle_number) {
                      return <div>
                        <p style="font-size:10px;">{time}</p>
                        <p>{vehicle_number}</p>
                      </div>;
                    }
                    return value;
                  },
                },
                {
                  title: '30T',
                  dataIndex: `${header}__30T`,
                  width: 80,
                  align: 'center',
                  customCell: (record, rowIndex) => {
                    return {
                      style: {
                        fontSize: '11px',
                      }
                    };
                  },
                  customRender: (value, record, index) => {
                    let vehicle_type = "30";
                    let time = record[`${header}__${vehicle_type}T`];
                    let vehicle_number = record[`${header}__${vehicle_type}__vehicle_number`];
                    if (time && vehicle_number) {
                      return <div>
                        <p style="font-size:10px;">{time}</p>
                        <p>{vehicle_number}</p>
                      </div>;
                    }
                    return value;
                  },
                },
              ]
            },
            {
              title: '到达',
              dataIndex: `${header}__time`,
              width: 80,
              align: 'center',
              customCell: (record, rowIndex) => {
                let [departure, destination] = header.split('-');
                if (destination === '郑州') {
                  return {
                    style: {
                      backgroundColor: '#FFD400',
                      fontSize: '11px',
                    },
                  };
                }
                if (destination === '驻马店') {
                  return {
                    style: {
                      backgroundColor: '#A6DFF2',
                      fontSize: '11px',
                    },
                  };
                }
                return {
                  style: {
                    backgroundColor: '#F6FFED',
                    fontSize: '11px',
                  },
                };
              },
              customRender: (value, record, index) => {
                let vehicle_type = record[`${header}__vehicle_type`];
                let vehicle_number = record[`${header}__${vehicle_type}__vehicle_number`];
                let vehicle_times1 = record[`${header}__${vehicle_type}__vehicle_times1`];
                let vehicle_times2 = record[`${header}__${vehicle_type}__vehicle_times2`];
                if (record[`${header}__time`]) {
                  if (vehicle_times1 > 0 || vehicle_times2 > 0) {
                    return <div>
                      <p style="font-size:10px;">{record[`${header}__time`]}</p>
                      <p style="color:red;">{vehicle_number}</p>
                    </div>;
                  }
                  else {
                    return <div>
                      <p style="font-size:10px;">{record[`${header}__time`]}</p>
                      <p>{vehicle_number}</p>
                    </div>;
                  }
                }
                return value;
              },
            }
          ],
        });
      }
      let list = [];
      let length = targets[0]?.ranges?.length || 0;
      let counts = {};
      for (let i = 0; i < length; i++) {
        let item = {};
        for (let j = 0; j < headers.length; j++) {
          let { from, to } = headers[j];
          let header = `${from}-${to}`;
          let target = targets.find(n => n.from === from && n.to === to);
          let {
            type,
            vehicle_type,
            vehicle_number,
            vehicle_times1,
            vehicle_times2,
            time1,
            time2,
          } = target.ranges[i];
          if (vehicle_number && type === 2) {
            if (vehicle_times2 > 0) {
              vehicle_number += `(${vehicle_times2})`;
            }
            else if (vehicle_times1 > 0) {
              vehicle_number += `(+${vehicle_times1})`;
            }
          }
          item[`${header}__vehicle_type`] = vehicle_type;
          item[`${header}__12T`] = vehicle_type === "12" && vehicle_number ? time1 : "";
          item[`${header}__12__vehicle_times1`] = vehicle_type === "12" && vehicle_times1 ? vehicle_times1 : 0;
          item[`${header}__12__vehicle_times2`] = vehicle_type === "12" && vehicle_times2 ? vehicle_times2 : 0;
          if (item[`${header}__12T`]) {
            if (!counts[`${header}__12T`]) counts[`${header}__12T`] = 0;
            counts[`${header}__12T`] = counts[`${header}__12T`] + 1;
          }
          item[`${header}__12__vehicle_number`] = vehicle_type === "12" ? vehicle_number || "" : "";

          item[`${header}__30T`] = vehicle_type === "30" && vehicle_number ? time1 : "";
          item[`${header}__30__vehicle_times1`] = vehicle_type === "30" && vehicle_times1 ? vehicle_times1 : 0;
          item[`${header}__30__vehicle_times2`] = vehicle_type === "30" && vehicle_times2 ? vehicle_times2 : 0;
          if (item[`${header}__30T`]) {
            if (!counts[`${header}__30T`]) counts[`${header}__30T`] = 0;
            counts[`${header}__30T`] = counts[`${header}__30T`] + 1;
          }
          item[`${header}__30__vehicle_number`] = vehicle_type === "30" ? vehicle_number || "" : "";
          item[`${header}__time`] = time2 || "";
        }
        list.push(item);
      }
      this.data = list;
      columns.forEach(n => {
        let keys = _.keys(counts);
        for (let key of keys) {
          if (key.includes(n.title)) {
            n.children.forEach(m => {
              if (m.title === "出发") {
                m.children.forEach(o => {
                  if (o.dataIndex === key) {
                    o.title = `${o.title}(${counts[key]})`
                  }
                });
              }
            });
          }
        }
      });
      this.columns = columns;
    },
  },
};
</script>
<style lang="less" scoped>
/deep/ .ant-table-header-column {
  font-size: 12px;
}

/deep/ .ant-table-row-cell-break-word {
  padding: 0 !important;
}

/deep/ .ant-table-small>.ant-table-content>.ant-table-scroll>.ant-table-body>table>.ant-table-thead>tr>th {
  padding: 0;
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}

/deep/ .ant-table-thead {
  font-size: 10px !important;
}

/deep/ .ant-collapse>.ant-collapse-item>.ant-collapse-header {
  padding: 6px 8px;
  padding-left: 30px;
}

/deep/ p {
  margin: 0;
  padding: 0;
}
</style>
